export default {"betTypeFilters":"_7hSb9"};